import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const CopyRight = () => (
  <div className="layoutOuter__copyRightBlock">
    <div className="layoutOuter__copyDate">
      <FormattedMessage
        id="copyRight"
      />
      <FormattedDate
        value={Date.now()}
        year="numeric"
      />
    </div>
    <FormattedMessage
      id="login.contactUs"
      values={{
        p: (...chunks) => <p className="layoutOuter__contactUs">{chunks}</p>,
        bold: (chunks) => <b>{chunks}</b>,
        link: (chunks) => (<a href="mailto:support@openforestprotocol.org" className="layoutOuter__contactUsEmail">{chunks}</a>),
      }}
    />
  </div>
);

export default CopyRight;
